var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPxEnglish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "British flag icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M24,12 C24,18.6274184 18.6274184,24 12,24 C5.3725816,24 0,18.6274184 0,12 C0,5.3725816 5.3725816,0 12,0 C18.6274184,0 24,5.3725816 24,12 L24,12 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,12 C24,18.6274184 18.6274184,24 12,24 C5.3725816,24 0,18.6274184 0,12 C0,5.3725816 5.3725816,0 12,0 C18.6274184,0 24,5.3725816 24,12 L24,12 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,12 C24,18.6274184 18.6274184,24 12,24 C5.3725816,24 0,18.6274184 0,12 C0,5.3725816 5.3725816,0 12,0 C18.6274184,0 24,5.3725816 24,12 L24,12 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,12 C24,18.6274184 18.6274184,24 12,24 C5.3725816,24 0,18.6274184 0,12 C0,5.3725816 5.3725816,0 12,0 C18.6274184,0 24,5.3725816 24,12 L24,12 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,12 C24,18.6274184 18.6274184,24 12,24 C5.3725816,24 0,18.6274184 0,12 C0,5.3725816 5.3725816,0 12,0 C18.6274184,0 24,5.3725816 24,12 L24,12 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,12 C24,18.6274184 18.6274184,24 12,24 C5.3725816,24 0,18.6274184 0,12 C0,5.3725816 5.3725816,0 12,0 C18.6274184,0 24,5.3725816 24,12 L24,12 Z",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,12 C24,18.6274184 18.6274184,24 12,24 C5.3725816,24 0,18.6274184 0,12 C0,5.3725816 5.3725816,0 12,0 C18.6274184,0 24,5.3725816 24,12 L24,12 Z",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,12 C24,18.6274184 18.6274184,24 12,24 C5.3725816,24 0,18.6274184 0,12 C0,5.3725816 5.3725816,0 12,0 C18.6274184,0 24,5.3725816 24,12 L24,12 Z",
    id: "path-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,12 C24,18.6274184 18.6274184,24 12,24 C5.3725816,24 0,18.6274184 0,12 C0,5.3725816 5.3725816,0 12,0 C18.6274184,0 24,5.3725816 24,12 L24,12 Z",
    id: "path-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,12 C24,18.6274184 18.6274184,24 12,24 C5.3725816,24 0,18.6274184 0,12 C0,5.3725816 5.3725816,0 12,0 C18.6274184,0 24,5.3725816 24,12 L24,12 Z",
    id: "path-19"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1.-LFM-flow-\\u2013-Rewe-case",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1a.-Language-selection-\\u2013-LFM-\\u2013-Rewe-\\u2013-mvp",
    transform: "translate(-16.000000, -468.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "::-Body",
    transform: "translate(0.000000, 330.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "px-english",
    transform: "translate(16.000000, 138.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-3-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#BE3431",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    points: "9.6930089 24 14.6230504 24 14.6230504 0 9.6930089 0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-5-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#BE3431",
    fillRule: "nonzero",
    mask: "url(#mask-4)",
    points: "0 14.2866231 24 14.2866231 24 9.31973412 0 9.31973412"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-6-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-6",
    fill: "#BE3431",
    fillRule: "nonzero",
    mask: "url(#mask-6)",
    points: "32.5038338 21.8092344 32.5038338 19.8728546 24.4103501 15.8182077 20.7763086 15.8182077 32.5038338 21.8092344"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-7-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-7",
    fill: "#BE3431",
    fillRule: "nonzero",
    mask: "url(#mask-8)",
    points: "-7.70939822 1.78226706 -7.70939822 3.63962493 0.0536973294 7.52882136 3.53946588 7.52882136 -7.70939822 1.78226706"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-8-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-8",
    fill: "#28265D",
    fillRule: "nonzero",
    mask: "url(#mask-10)",
    points: "8.01628487 -0.0484557864 8.01628487 6.91756914 -5.75866113 -0.0484557864 8.01628487 -0.0484557864"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-9-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-9",
    fill: "#28265D",
    fillRule: "nonzero",
    mask: "url(#mask-12)",
    points: "16.2107537 -0.0484557864 16.2107537 6.91756914 29.9857567 -0.0484557864 16.2107537 -0.0484557864"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-10-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-10",
    fill: "#BE3431",
    fillRule: "nonzero",
    mask: "url(#mask-14)",
    points: "20.718908 7.46019703 32.5172226 1.67175312 32.5172226 -0.0484557864 16.9508368 7.48288665 20.718908 7.46019703"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-11-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-11",
    fill: "#BE3431",
    fillRule: "nonzero",
    mask: "url(#mask-16)",
    points: "4.08484273 15.8583739 -7.71338635 21.6468605 -7.71338635 23.3670267 7.85305638 15.8355846 4.08484273 15.8583739"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-12-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-12",
    fill: "#28265D",
    fillRule: "nonzero",
    mask: "url(#mask-18)",
    points: "8.01628487 23.3918101 8.01628487 16.4258279 -5.75866113 23.3918101 8.01628487 23.3918101"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-13-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-20",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-13",
    fill: "#28265D",
    fillRule: "nonzero",
    mask: "url(#mask-20)",
    points: "16.2107537 23.3918101 16.2107537 16.4258279 29.9857567 23.3918101 16.2107537 23.3918101"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPxEnglish);
export default __webpack_public_path__ + "static/media/px-english.d09dae1d898a6f09c817a80e64133b84.svg";
export { ForwardRef as ReactComponent };